import { Injectable, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { RequestService } from '@seu-services';
import {
  SEU_API_ENDPOINTS,
  SeuDefaultUnit,
  SeuDefaultUnitPayload,
  SeuDefaultUnitResponseApi,
} from '@seu-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  private readonly requestService = inject(RequestService);

  private readonly formGroup = new FormGroup({});

  private readonly defaultUnits = new Map<string, string>();

  // Set one default unit e.g. after dropdown changed
  public async setDefaultUnit(
    offerId: string,
    unitKey: string,
    unitValue: string
  ): Promise<void> {
    if (this.defaultUnits.get(unitKey) === unitValue) {
      return;
    }

    const endpoint = SEU_API_ENDPOINTS.defaultUnits.replace(
      ':offerId',
      offerId
    );

    const data: SeuDefaultUnitPayload = {
      key: unitKey,
      value: unitValue,
    };

    const responseData = await firstValueFrom(
      this.requestService.post<SeuDefaultUnitResponseApi>(
        endpoint as SEU_API_ENDPOINTS,
        data
      )
    );

    if (responseData) {
      this.defaultUnits.set(responseData.key, responseData.value);
    }
  }

  // Set all default units e.g. after offer loaded
  public setDefaultUnits(defaultUnits: SeuDefaultUnit[]): void {
    this.defaultUnits.clear();

    defaultUnits.forEach((unit) => {
      this.defaultUnits.set(unit.key, unit.value);
    });
  }

  public getFormControlByUnitKey(
    unitKey: string,
    defaultOption: string | undefined
  ): FormControl {
    const formControl = this.formGroup.get(unitKey);

    if (!formControl) {
      this.formGroup.addControl(
        unitKey,
        new FormControl(this.defaultUnits.get(unitKey) ?? defaultOption, [])
      );
    }

    return this.formGroup.get(unitKey) as FormControl;
  }
}
